import { useEffect } from 'react';

import useBackEventHandler from '@/hooks/useBackEventHandler';

interface Props {
  isBackEventTrigger: boolean;
  callback?: () => void;
}

const useWebViewBackEventHandler = (props: Props) => {
  const { isBackEventTrigger, onPreventBackEvent } = useBackEventHandler();

  useEffect(() => {
    onPreventBackEvent(props.isBackEventTrigger);
  }, [props.isBackEventTrigger, onPreventBackEvent]);

  useEffect(() => {
    if (isBackEventTrigger) {
      props.callback?.();
    }
  }, [isBackEventTrigger, props]);
};

export default useWebViewBackEventHandler;
